import React from "react";
import Select from "react-select";
import { Label } from "reactstrap";
import { ISearchableSelect } from "../../../interfaces/Index";
import downArrowIcon from "../../../assets/images/down-arrow.svg";
import "./SearchableSelect.scss";
const SearchableSelect = (props: ISearchableSelect) => {
  return (
    <div className="searchable-select-container form-group">
      {props.label && (
        <Label className="block text-uppercase label">
          {props.label}
          {props.isOptional ? (
            <span className="optional"> (optional)</span>
          ) : (
            ""
          )}
        </Label>
      )}
      <Select
        id={props.id}
        className="searchable-select"
        classNamePrefix="select"
        isSearchable={props.isSearchable}
        options={props.options}
        onChange={props.onChange}
        value={props.selectedValue}
        placeholder={props.placeholder}
        defaultOptions={props.defaultOptions}
        isDisabled={props.isDisabled}
      />
      <img src={downArrowIcon} />
    </div>
  );
};

SearchableSelect.defaultProps = {
  isOptional: false,
};

export default SearchableSelect;
